import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SysAdminService } from "../../services/sysadmin.service";
import { RolesToChangeModel } from "./RolesToChangeModel";
import { UserGroupAddRolesComponent } from "./user-group-add-roles/user-group-add-roles.component";

@Component({
	selector: "caass-user-group-role-table",
	templateUrl: "./user-group-role-table.component.html",
	styleUrls: ["./user-group-role-table.component.css"],
})
export class UserGroupRoleTableComponent implements OnInit {
	constructor(private sysAdminService: SysAdminService, private dialogService: DialogService) {}

	ngOnInit(): void {}

	ngOnChanges() {
		this.errorMessage = "";

		if (this.SelectedUserGroup != undefined && this.SelectedUserGroup != null) {
			this.loadRoleList();
		} else {
			this.lstRoles = [];
		}
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	@Input() SchoolID: any;
	@Input() UserLevelID: any = 0;
	@Input() SelectedUserGroup: any;

	lstRoles: any = [];
	SelectedRoles: any = [];

	cols = [{ field: "RoleDesc", header: "User Role" }];

	pagerows: any = 5;
	pagefirst: any = 0;

	errorMessage: any = "";

	loading: any = false;

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	private loadRoleList() {
		this.loading = true;

		var result = this.sysAdminService.RoleGetListByUserGroup(this.SelectedUserGroup.UserGroupID);
		result.subscribe(
			(response) => {
				this.lstRoles = response;
				this.SelectedRoles = [];

				this.loading = false;
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		if (this.SelectedUserGroup == undefined || this.SelectedUserGroup == null) {
			this.errorMessage = "Select a User Group to add roles to";
			return;
		}

		var ref = this.dialogService.open(UserGroupAddRolesComponent, {
			header: "Add Roles",
			width: "fit-content",
			data: {
				UserLevelID: this.SelectedUserGroup.UserLevelID,
				SchoolID: this.SchoolID,
				SelectedRoles: this.lstRoles,
				UserGroupID: this.SelectedUserGroup.UserGroupID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadRoleList();
			}
		});
	}

	onRemove() {
		this.errorMessage = "";

		// if(this.SelectedRoles.length == 0){
		//   this.errorMessage = "Select roles to remove";
		//   return;
		// }

		var lstRoleID: string[] = [];

		for (var i = 0; i < this.SelectedRoles.length; i++) {
			var next = String(this.SelectedRoles[i].RoleId);
			lstRoleID = [...lstRoleID, next];
		}

		//Create Query Data
		let data: RolesToChangeModel = {
			UserGroupID: this.SelectedUserGroup.UserGroupID,
			RoleIDs: lstRoleID,
		};

		//Call SP
		var result = this.sysAdminService.UserGroupRemoveRoles(data);
		result.subscribe(
			(response) => {
				this.loadRoleList();
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	/////////////////////////////////////////
}
